module.exports = __webpack_public_path__ + "static/temoignage3-e59c61bb9e30748ac890aab628491421.png";